import * as React from 'react';
import { MVK, NewbuildingMvkContext } from '@cian/frontend-newbuilding-mvk-widget';
import { ModalFullscreen } from '@cian/ui-kit/modal';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenFloorPlan } from '../../actions/floorPlan';
import { FloorPlanHeader } from '../../components/FloorPlanHeader';
import { getHouseId, isFloorPlanEnabled, isFloorPlanOpened } from '../../selectors/floorPlan';
import { getNewbuildingId } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/applicationContext';

export const FloorPlan = () => {
  const dispatch = useDispatch();

  const { httpApi, logger } = useApplicationContext();
  const contextValue = React.useMemo(() => ({ httpApi, logger }), [httpApi, logger]);

  const isOpened = useSelector(isFloorPlanOpened);
  const isEnabled = useSelector(isFloorPlanEnabled);
  const newbuildingId = useSelector(getNewbuildingId);
  const houseId = useSelector(getHouseId);

  const onClose = () => {
    dispatch(setOpenFloorPlan(false));
  };

  if (!isOpened || !isEnabled) {
    return null;
  }

  return (
    <ModalFullscreen escape open print theme="white" onClose={onClose}>
      <FloorPlanHeader onClose={onClose} />
      <NewbuildingMvkContext.Provider value={contextValue}>
        <MVK newbuildingId={newbuildingId} houseId={houseId} sectionId={null} />
      </NewbuildingMvkContext.Provider>
    </ModalFullscreen>
  );
};
